import { isEqual, sortBy } from 'lodash';

export const isOtherProductsChanged = (
	installationSerialNumbers: string[],
	otherPartsInstallationSerialNumbers: string[]
) =>
	!isEqual(
		sortBy(installationSerialNumbers),
		sortBy(otherPartsInstallationSerialNumbers)
	);
